import React, { InputHTMLAttributes } from 'react';
import { format } from 'date-fns';

import styles from '../Fields.module.css';

function DateField({
  className = '',
  ref,
  ...fieldProps
}: InputHTMLAttributes<HTMLInputElement> & { ref?: React.Ref<HTMLInputElement> }) {
  return (
    <input
      type='date'
      pattern='(d){2}-(d){2}-(d){4}'
      id='inregel-date-picker'
      data-testid='inregel-date-picker'
      min={format(new Date(), 'yyyy-MM-dd')}
      ref={ref}
      {...fieldProps}
      className={`${styles.inputField} ${styles.dateField} ${className}`}
      onFocus={(event) => {
        event.target.select();
        if (fieldProps?.onFocus) fieldProps.onFocus(event);
      }}
      onChange={(event) => {
        let dateValue = event.target.value;
        if (new RegExp(/\d{8}/g).exec(dateValue)?.length) {
          dateValue = dateValue.replace(dateValue.charAt(1), `${dateValue.charAt(1)}:`);
          event.currentTarget.value = dateValue;
          event.target.value = dateValue;
        }
        if (fieldProps?.onChange)
          fieldProps.onChange({
            ...event,
            target: { ...event.target, value: dateValue },
          });
      }}
    />
  );
}
export default DateField;
